import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { path, propOr } from 'ramda';
import { graphql, compose, Query } from 'react-apollo';
import FormHelperText from '@material-ui/core/FormHelperText';
import LinearProgress from '@material-ui/core/LinearProgress';
import AppSettings from './AppSettings';
import { GET_APPLICATION, UPDATE_APPLICATION } from './queries';

class ApplicationProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  updateApp = (application, currentTeam) => {
    const { updateApp } = this.props;
    updateApp({
      variables: {
        application,
        currentTeam,
      },
      refetchQueries: [{ query: GET_APPLICATION, variables: { applicationID: path(['match', 'params', 'id'], this.props) } }],
    });
  };

  render() {
    return (
      <Query
        query={GET_APPLICATION}
        variables={{ applicationID: path(['match', 'params', 'id'], this.props) }}
        fetchPolicy="network-only"
        notifyOnNetworkStatusChange
      >
        {({ data, loading, error }) => {
          if (error) return <FormHelperText error>Unable to load applications</FormHelperText>;
          if (loading) return <LinearProgress />;
          return (
            <AppSettings
              application={propOr({}, 'application', data)}
              refreshApp={this.updateApp}
              {...this.props}
            />
          );
        }}
      </Query>
    );
  }
}

// export default ApplicationProvider;
export default compose(
  graphql(UPDATE_APPLICATION, { name: 'updateApp' }),
)(ApplicationProvider);

ApplicationProvider.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
  updateApp: PropTypes.func,
};

ApplicationProvider.defaultProps = {
  updateApp: () => { },
};
